import React, { useEffect } from "react";
import L from 'leaflet';
import { firstCircleLat, firstCircleLong, secondCircleLat, secondCircleLong, thirdCircleLat, thirdCircleLong } from './../constants/dataMapCoverage.jsx'
import { useState } from "react";
import { MAPBOXDATA } from "../constants/mapboxData.js";


export function MapCoverage({ satellite, mapPolygons, powerLevelWithCoord, beam }) {

    const polygonStyle = { fillColor: '#3388ff', fillOpacity: 0.1, color: '#fff', weight: 1 };
    const options = { weight: 1, color: '#000' };
    const [displayBeam,setDisplayBeam] = useState(false);

    useEffect(() => {
        if (mapPolygons.length > 0) {
            setDisplayBeam(true)
            var map = L.map('map').setView([61.83,-0], 2);
            var mapLayer = L.tileLayer(MAPBOXDATA.LAYER+MAPBOXDATA.TOKEN
            , {
                zoom: 2,
                maxZoom:4
            });

            map.addLayer(mapLayer);

            L.control.scale().addTo(map);

            for (const [powerLevelCoordinate, powerLevelValue] of powerLevelWithCoord.entries()) {
                L.marker(powerLevelCoordinate, { icon: new L.DivIcon({ html: powerLevelValue }) }).addTo(map)
            }

            //dessine les couvertures
            mapPolygons.forEach(element => {
                L.polygon(element, polygonStyle).addTo(map);
            });

            if (typeof satellite.orbitSlot !== "undefined") {
                let elevationAngle = [[], [], []];
                let orbitSlot = satellite.orbitSlot;

                if (beam.longitude360) {
                    orbitSlot = 360 + orbitSlot
                }

                for (let i = 0; i < firstCircleLat.length; i++) {
                    elevationAngle[0].push([firstCircleLat[i], firstCircleLong[i] + orbitSlot]);
                }
                L.marker(elevationAngle[0][0], { icon: new L.DivIcon({ html: "0°" }) }).addTo(map)
                L.polyline(elevationAngle[0], options).addTo(map);


                for (let i = 0; i < secondCircleLat.length; i++) {
                    elevationAngle[1].push([secondCircleLat[i], secondCircleLong[i] + orbitSlot]);
                }
                L.marker(elevationAngle[1][0], { icon: new L.DivIcon({ html: "10°" }) }).addTo(map)
                L.polyline(elevationAngle[1], options).addTo(map);

                for (let i = 0; i < thirdCircleLat.length; i++) {
                    elevationAngle[2].push([thirdCircleLat[i], thirdCircleLong[i] + orbitSlot]);
                }
                L.marker(elevationAngle[2][0], { icon: new L.DivIcon({ html: "20°" }) }).addTo(map)
                L.polyline(elevationAngle[2], options).addTo(map);
            }

            return () => map.remove();
        }
    }, [satellite, mapPolygons, powerLevelWithCoord]);

    return (
        <div className="beamImage">
            {
                !displayBeam && (
                    <p id="msgNoBeam">No beam to display</p>
                )
            }
        </div>
    );
}
export default MapCoverage;